import "./index.css";
import { BsWallet } from "react-icons/bs";
import { MdAddCircleOutline } from "react-icons/md";
import $ from "jquery";

import {
  GiWallet,
  GiMoneyStack,
  GiTakeMyMoney,
  GiReceiveMoney,
  GiPayMoney,
} from "react-icons/gi";

function Wallet({ wallet, currentStocks, total, profits, loses, balance }) {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="mb-1 pl-sm-1 p-0 col-lg col-md-4 col-sm-6 col-12">
          <div
            className="card text-white bg-primary text-center"
            style={{ height: "5.2rem" }}
          >
            <div className="card-header p-1 d-flex align-items-center justify-content-between">
              رصيد المحفظة
              <BsWallet size="1.5em" />
            </div>
            <div className="card-body bg-light text-secondary font-weight-bold d-flex justify-content-center position-relative p-0">
              <p className="d-flex align-items-center justify-content-center m-0 ">
                {wallet}{" "}
                {+wallet === 0 ? (
                  <span data-toggle="modal" data-target="#settingsModal">
                    <button
                      className="btn btn-link mr-2 position-absolute p-0"
                      id="addMoney"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      onClick={() => $("button").tooltip("hide")}
                      title="اضافة رصيد"
                    >
                      {" "}
                      <MdAddCircleOutline size="1.5em" />{" "}
                    </button>
                  </span>
                ) : (
                  ""
                )}
              </p>
            </div>
          </div>
        </div>
        <div className=" mb-1 pl-sm-0 pl-md-1 p-0 col-lg-2 col-md-4 col-sm-6 col-12">
          <div
            className="card text-white bg-primary text-center"
            style={{ height: "5.2rem" }}
          >
            <div className="card-header p-1 d-flex align-items-center justify-content-between">
              رصيد الصفقات الحالية <GiWallet size="1.5em" />
            </div>
            <div className="card-body bg-light text-secondary font-weight-bold d-flex justify-content-around p-0">
              <p className="d-flex align-items-center justify-content-center m-0">
                {currentStocks.toFixed(2)}
              </p>
              <p className="d-flex align-items-center justify-content-center m-0">
                |
              </p>
              <p className="d-flex align-items-center justify-content-center m-0">
                {wallet > 0
                  ? ((currentStocks / (+wallet + +total)) * 100).toFixed(2)
                  : 0}
                &rlm;{"%"}
              </p>
            </div>
          </div>
        </div>
        <div className="mb-1 pl-md-0 pl-sm-1 pl-lg-1 p-0 col-lg col-md-4 col-sm-6 col-12">
          <div
            className="card text-white bg-primary text-center"
            style={{ height: "5.2rem" }}
          >
            <div className="card-header p-1 d-flex align-items-center justify-content-between">
              الرصيد المتوفر
              <GiTakeMyMoney size="1.5em" />
            </div>
            <div className="card-body bg-light text-secondary font-weight-bold d-flex justify-content-around p-0">
              <p className="d-flex align-items-center justify-content-center m-0">
                {wallet > 0 ? (+total + +balance).toFixed(2) : 0}
              </p>
              <p className="d-flex align-items-center justify-content-center m-0">
                |
              </p>
              <p className="d-flex align-items-center justify-content-center m-0">
                {wallet > 0
                  ? (((+balance + +total) / wallet) * 100).toFixed(2)
                  : 0}
                &rlm;{"%"}
              </p>
            </div>
          </div>
        </div>
        <div className="mb-1 pl-sm-0 pl-md-1 p-0 col-lg col-md-4 col-sm-6 col-12">
          <div
            className="card text-white bg-primary text-center"
            style={{ height: "5.2rem" }}
          >
            <div className="card-header p-1 d-flex justify-content-between align-items-center">
              الارباح
              <GiReceiveMoney size="1.5em" />
            </div>
            <div className="card-body bg-light text-success font-weight-bold d-flex justify-content-around p-0">
              <p className="d-flex align-items-center justify-content-center m-0">
                {profits.toFixed(2)}
              </p>
              <p className="d-flex align-items-center justify-content-center m-0">
                |
              </p>
              <p className="d-flex align-items-center justify-content-center m-0">
                {"%"}
                {wallet > 0 ? ((profits / wallet) * 100).toFixed(2) : 0}
              </p>
            </div>
          </div>
        </div>
        <div className="mb-1 pl-sm-1 p-0 col-lg col-md-4 col-sm-6 col-12">
          <div
            className="card text-white bg-primary text-center"
            style={{ height: "5.2rem" }}
          >
            <div className="card-header p-1 d-flex justify-content-between align-items-center">
              الخسائر
              <GiPayMoney size="1.5em" />
            </div>
            <div className="card-body  bg-light text-danger font-weight-bold d-flex justify-content-around p-0">
              <p className="d-flex align-items-center justify-content-center m-0">
                {loses.toFixed(2)}
              </p>
              <p className="d-flex align-items-center justify-content-center m-0">
                |
              </p>
              <p className="d-flex align-items-center justify-content-center m-0">
                {wallet > 0 ? ((loses / wallet) * 100).toFixed(2) : 0}
                &rlm;{"%"}
              </p>
            </div>
          </div>
        </div>
        <div className="mb-1 p-0 col-lg-3 col-md-4 col-sm-6 col-12">
          <div
            className="card text-white bg-primary text-center"
            style={{ height: "5.2rem" }}
          >
            <div className="card-header p-1 d-flex justify-content-between align-items-center">
              الاجمالي
              <GiMoneyStack size="1.5em" />
            </div>
            <div className="card-body p-0 bg-light text-secondary font-weight-bold d-flex flex-column justify-content-center">
              <div className="d-flex justify-content-around ">
                <div>
                  <small className="p-0 m-0">الارباح/الخسائر</small>
                  <p
                    className={
                      "d-flex align-items-center justify-content-center m-0 p-0 " +
                      (total < 0 ? "text-danger" : "text-success")
                    }
                  >
                    {total.toFixed(2)}
                  </p>
                </div>
                <div>
                  <small className="p-0 m-0">النسبة</small>
                  <p
                    className={
                      "d-flex align-items-center justify-content-center m-0 p-0 " +
                      (total < 0 ? "text-danger" : "text-success")
                    }
                  >
                    {wallet > 0 ? ((total / wallet) * 100).toFixed(2) : 0}
                    &rlm;{"%"}
                  </p>
                </div>
                <div>
                  <small className="p-0 m-0">الرصيد</small>
                  <p
                    className={
                      "d-flex align-items-center justify-content-center m-0 p-0 " +
                      (+total + +wallet < wallet
                        ? "text-danger"
                        : "text-success")
                    }
                  >
                    {(+total + +wallet).toFixed(2)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Wallet;
